<div class="cmp-breadcrumbs" [ngClass]="{'mt-0': mt_0}" role="navigation">
  <nav class="breadcrumb-container" aria-label="breadcrumb">
    <ol class="breadcrumb p-0" data-element="breadcrumb">
      <li class="breadcrumb-item"><a href="/">Home</a><span class="separator">/</span></li>
      <ng-container *ngFor="let breadcrumb of breadcrumbs; let last =last">
        <li class="breadcrumb-item"><a href="{{breadcrumb.url}}" *ngIf="!last">{{breadcrumb.title}}</a><span
            class="separator" *ngIf="!last">/</span>
        </li>
        <li class="breadcrumb-item active" *ngIf="last">{{breadcrumb.title}}</li>
      </ng-container>
    </ol>
  </nav>
</div>